import type { WallpaperData } from "../types";

const wallpapers: WallpaperData = {
  day: "img/ui/wallpaper-day.jpg",
  night: "img/ui/wallpaper-night.jpg"
};

export default wallpapers;
